import React from 'react';
import { IoLinkOutline } from 'react-icons/io5';
//
import LoadingCircle from '../../components/LoadingCircle';
//
import styles from './redirect.module.css';

interface RedirectProps {
  /** Texto principal acima do loader */
  title?: string;
  /** Subtítulo/instrução */
  message?: string;
}

export default function Redirect({ title, message }: RedirectProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['card']}>
        <div className={styles['icon-wrapper']}>
          <IoLinkOutline className={styles['icon']} />
        </div>

        <h1 className={styles['title']}>{title ?? 'Aguardando link da fatura'}</h1>

        <p className={styles['message']}>
          {message ??
            'Para visualizar uma cobrança, acesse o link enviado por SMS, e-mail ou WhatsApp pela operadora.'}
        </p>

        <div className={styles['loader']}>
          <LoadingCircle />
          <span>Verificando…</span>
        </div>
      </div>
    </div>
  );
}
